import React, { useContext } from 'react'
import { ShowReportsContext } from '../../../hooks/context/ShowReportsContext';


const Reports = ({view}) => {
  const showReportsCtx: any = useContext(ShowReportsContext);
  return (
    <>
    </>
  )
}

export default Reports